import { RecurrenceFrequency } from "gql/graphql";

/**
 * Частоты повтора в порядке от частой к редкой. Селекты формы и фильтра строят по ним
 * свои пункты, поэтому порядок задан в одном месте.
 */
export const RECURRENCE_FREQUENCIES = [
  RecurrenceFrequency.Daily,
  RecurrenceFrequency.Weekly,
  RecurrenceFrequency.Monthly,
  RecurrenceFrequency.Quarterly,
  RecurrenceFrequency.Yearly,
] as const;
